module.exports = __webpack_public_path__ + "img/purchase_insurance.408cfb60.svg";